import {css} from '@emotion/react'
import {Tooltip} from 'antd'
import {useMapContext} from '@/components/MindMap'

const cssNodeDiff = css({
    width: 13,
    height: 13,
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 1,
    textAlign: 'center',
    pointerEvents: 'auto',
})

const DiffTitleA = (props) => {
    return <div {...props}>此节点是新增的节点，在参照地图中不存在</div>
}

const DiffTitleD = (props) => {
    return <div {...props}>此节点在参照地图中已被删除</div>
}

const cssModifications = css({
    'table': {
        marginTop: 8,
    },

    'th, td': {
        border: '1px solid',
        padding: 4,
    },
})

const DiffTitleM = ({modifications, ...props}) => {
    const trs = modifications.map(
        ([name, v1, v2]) => (
            <tr key={name}>
                <th>{name}</th>
                <td>{v1} → {v2}</td>
            </tr>
        )
    )

    return (
        <div
            css={cssModifications}
            {...props}
        >
            <div>此节点已改变</div>

            <table>
                <tbody>
                    {trs}
                </tbody>
            </table>
        </div>
    )
}

export default function NodeDiff({node, ...props}) {
    const map = useMapContext()
    const [diffType, extra] = map.useNodeDiff(node)

    if (! diffType) {
        return null
    }

    const title = ({
        A: () => <DiffTitleA />,
        D: () => <DiffTitleD />,
        M: () => <DiffTitleM modifications={extra} />,
    }[diffType])()

    return (
        <Tooltip
            css={cssNodeDiff}
            placement="right"
            title={title}
            {...props}
        >
            {diffType}
        </Tooltip>
    )
}
